var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-list-column',{staticClass:"column",attrs:{"format":_vm.format}},[_vm._v(_vm._s(_vm.format.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }